import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAccountStore = defineStore('account', () => {
  const selectedAccountName = ref<string | null>(null)
  const selectedAccountFolder = ref<string | null>(null)
  const accountsCache = ref<any[]>([])
  const productsCache = ref<any[]>([])
  const productsCacheByAccount = ref<Record<string, any[]>>({})
  const companyUsersCache = ref<any[]>([]) // company user list cache (Users.vue company role)
  const companyClientsCache = ref<any[]>([]) // clients list shown on Users.vue (does not include JUID)
  const clientAccountsUsersCache = ref<any[]>([]) // client accounts page list (includes JUID/friendly)
  const clientUsersCache = ref<any[]>([]) // client users cache for Client Accounts page
  const selectedAccountData = ref({
    accountName: '',
    websiteUrl: '',
    juid: '',
    a5Account: '',

    primaryContact: {
      name: '',
      email: '',
      phone: '',
    },
    billing: {
      name: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
    },
    notes: '',
    secondaryProducts: ['fordDirect'],
    // "a5Account": "",
    paCode: '',
    accountNameFriendly: '',
  })

  const setSelectedAccountData = (data: any) => {
    selectedAccountData.value = data
  }

  const setSelectedAccount = (account: any) => {
    selectedAccountName.value = account.name
    selectedAccountFolder.value = account.folder
  }

  const setAccountsCache = (accounts: any[]) => {
    accountsCache.value = Array.isArray(accounts) ? accounts.slice() : []
  }
  const setProductsCache = (products: any[]) => {
    productsCache.value = Array.isArray(products) ? products.slice() : []
  }
  const getProductsCacheForAccount = (accountKey: string): any[] | undefined => {
    const arr = productsCacheByAccount.value[accountKey]
    return Array.isArray(arr) ? arr.slice() : undefined
  }
  const setProductsCacheForAccount = (accountKey: string, products: any[]) => {
    productsCacheByAccount.value[accountKey] = Array.isArray(products) ? products.slice() : []
  }
  const clearProductsCacheForAccount = (accountKey: string) => {
    delete productsCacheByAccount.value[accountKey]
  }
  const setCompanyUsersCache = (users: any[]) => {
    companyUsersCache.value = Array.isArray(users) ? users.slice() : []
  }
  const setCompanyClientsCache = (users: any[]) => {
    companyClientsCache.value = Array.isArray(users) ? users.slice() : []
  }
  const setClientAccountsUsersCache = (users: any[]) => {
    clientAccountsUsersCache.value = Array.isArray(users) ? users.slice() : []
  }
  const setClientUsersCache = (users: any[]) => {
    clientUsersCache.value = Array.isArray(users) ? users.slice() : []
  }

  return {
    selectedAccountData,
    setSelectedAccountData,
    selectedAccountName,
    selectedAccountFolder,
    setSelectedAccount,
    accountsCache,
    setAccountsCache,
    productsCache,
    setProductsCache,
    productsCacheByAccount,
    getProductsCacheForAccount,
    setProductsCacheForAccount,
    clearProductsCacheForAccount,
    companyUsersCache,
    companyClientsCache,
    clientAccountsUsersCache,
    clientUsersCache,
    setCompanyUsersCache,
    setCompanyClientsCache,
    setClientAccountsUsersCache,
    setClientUsersCache,
  }
})
